import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrustCards from './components/TrustCards';
import SpreadsheetIntro from './components/SpreadsheetIntro';
import CategoriesSection from './components/CategoriesSection';
import ProductCarousels from './components/ProductCarousels';
import HowItWorks from './components/HowItWorks';
import GuidesSection from './components/GuidesSection';
import ComparisonSection from './components/ComparisonSection';
import SafetySection from './components/SafetySection';
import FAQSection from './components/FAQSection';
import PillarArticles from './components/PillarArticles';
import FinalCTA from './components/FinalCTA';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <main>
        <HeroSection />
        <TrustCards />
        <SpreadsheetIntro />
        <CategoriesSection />
        <ProductCarousels />
        <HowItWorks />
        <GuidesSection />
        <ComparisonSection />
        <SafetySection />
        <FAQSection />
        <PillarArticles />
        <FinalCTA />
      </main>

      <Footer />
    </div>
  );
}